import domready from 'domready';

/**
 * Initializes autoplay behavior for videos based on user motion preference.
 * - If the user **does not** prefer reduced motion, videos with `data-is-autoplay="1"` will autoplay.
 * - If the user **does** prefer reduced motion, those videos will instead display native controls.
 */
function initAutoplayVideos() {
  const isReduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const videos = document.querySelectorAll('video[data-is-autoplay="1"]');

  /**
   * @type {NodeListOf<HTMLVideoElement>}
   */
  videos.forEach((video) => {
    if (!isReduceMotion) {
      video.setAttribute('autoplay', '');
      video.play();
    } else {
      video.setAttribute('controls', '');
    }
  });
}

domready(() => {
  initAutoplayVideos();
});
